var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusDelivered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.14218 3.21928L21.2042 9.44488C21.5347 9.61542 21.7433 9.95522 21.7458 10.3271C21.7483 10.699 21.5444 11.0416 21.2162 11.2166L16.7143 13.6176C16.1345 13.927 15.4397 13.9318 14.8556 13.6306L2.79654 7.40302C2.46605 7.23248 2.25745 6.89268 2.25491 6.52079C2.25241 6.14889 2.45639 5.8063 2.78454 5.63129L7.28641 3.23029C7.86579 2.92262 8.55919 2.91851 9.14218 3.21928Z",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8586 3.21928L2.79654 9.44488C2.46605 9.61542 2.25745 9.95522 2.25491 10.3271C2.25241 10.699 2.45639 11.0416 2.78454 11.2166L7.28641 13.6176C7.86626 13.927 8.56106 13.9318 9.14519 13.6306L21.2042 7.40302C21.5347 7.23248 21.7433 6.89268 21.7458 6.52079C21.7483 6.14889 21.5444 5.8063 21.2162 5.63129L16.7143 3.23029C16.135 2.92262 15.4416 2.91851 14.8586 3.21928Z",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1083 12.3413V16.2789C19.1083 17.018 18.701 17.6969 18.0488 18.0447L12.9467 20.7688C12.3583 21.0825 11.6523 21.0825 11.0639 20.7688L5.96178 18.0447C5.30962 17.6969 4.90234 17.018 4.90234 16.2789V12.3413",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 21.004V12.1543",
    stroke: "#00B26B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDelivered);
export default __webpack_public_path__ + "static/media/status-delivered.4c964b1d1fa4e572a771f4017536bee6.svg";
export { ForwardRef as ReactComponent };